import React from 'react';

import { ItemComponentProps } from './interfaces';
import * as Styled from './styled';

const Item: React.FC<ItemComponentProps> = ({
  onChange,
  setValue,
  name,
  label,
  value,
  subtitle,
  checked = false,
  disabled = false,
  inputProps
}) => (
  <Styled.ItemWrapper hasSubtitle={!!subtitle}>
    <Styled.Input
      {...inputProps}
      type='radio'
      disabled={disabled}
      checked={checked}
      onChange={() => {
        setValue(value);

        if (onChange) {
          onChange(value);
        }
      }}
      value={value}
      id={`${name}_${value}`}
      name={name}
    />
    <Styled.Label htmlFor={`${name}_${value}`} subtitle={subtitle} label={label}>
      <Styled.Circle>
        <Styled.InnerCircle />
      </Styled.Circle>
      <Styled.TextWrapper>
        <Styled.Text>{label}</Styled.Text>
        {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
      </Styled.TextWrapper>
    </Styled.Label>
  </Styled.ItemWrapper>
);

export default React.memo(Item);
